export default __webpack_public_path__ + "static/media/5.81326c6e.jpg";